import { render, staticRenderFns } from "./video_demo.vue?vue&type=template&id=6f6f03ae&scoped=true"
import script from "./video_demo.vue?vue&type=script&lang=js"
export * from "./video_demo.vue?vue&type=script&lang=js"
import style0 from "./video_demo.vue?vue&type=style&index=0&id=6f6f03ae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6f03ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f6f03ae')) {
      api.createRecord('6f6f03ae', component.options)
    } else {
      api.reload('6f6f03ae', component.options)
    }
    module.hot.accept("./video_demo.vue?vue&type=template&id=6f6f03ae&scoped=true", function () {
      api.rerender('6f6f03ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/video_demo.vue"
export default component.exports